module.exports = __webpack_public_path__ + "static/media/address-e.7023882e.svg";